/* eslint-disable import/prefer-default-export */
export const reportOptions = [
  {
    label: 'Vendor Refund Report',
    reportType: 'vendorRefunds',
  },
];
